import _features from './features';

export const support = _features(window);
